import { Reveal } from "./Reveal";
import { MessagesSquare, Cpu, Smartphone, Rocket } from "lucide-react";

const STEPS = [
  {
    step: "STEP 01",
    title: "Converse & Blueprint",
    desc: "Speak your product spec naturally. Emergent's agent drafts the database schema, user personas, API contracts, and screen states.",
    icon: MessagesSquare,
  },
  {
    step: "STEP 02",
    title: "Autonomous Synthesis",
    desc: "Frontend components, backend endpoints, and third-party integrations (Stripe, Twilio, OpenAI) are generated and compiled simultaneously.",
    icon: Cpu,
  },
  {
    step: "STEP 03",
    title: "Live Interactive Sandbox",
    desc: "Test the live web app and scan a QR code to run the native Expo app instantly on your physical phone in under 60 seconds.",
    icon: Smartphone,
  },
  {
    step: "STEP 04",
    title: "One-Click Deploy & Git Sync",
    desc: "Push to production on your custom domain with automatic SSL, or export clean GitHub repositories.",
    icon: Rocket,
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="scroll-mt-24 border-t border-[#e8e8e4] bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#2563eb]">03 // The Pipeline</p>
        <h2 className="font-display mt-6 max-w-2xl text-2xl font-semibold leading-[1.15] text-[#0b0f1a] sm:text-3xl lg:text-4xl">
          From sentence to shipped in <span className="text-[#2563eb]">four moves</span>.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.step} delay={i * 0.1} className="h-full">
            <div
              data-testid={`how-it-works-step-${i + 1}`}
              className="card-lift group flex h-full flex-col rounded-3xl border border-[#e8e8e4] bg-[#f8f8f6] p-7"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">{s.step}</span>
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#eff4ff] text-[#2563eb] transition-colors duration-500 group-hover:bg-[#2563eb] group-hover:text-white">
                  <s.icon className="h-5 w-5" />
                </span>
              </div>
              <h3 className="font-display mt-8 text-lg font-semibold text-[#0b0f1a]">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-500">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
